<template>
  <section class="hero is-primary">
    <div class="hero-body pb-3">
      <div class="container pb-0">
        <div class="level is-mobile">
          <div class="level-item level-left">
            <router-link to="/" class="navbar-item is-hoverable">
              <img
                alt="AlfaPack_Logo_Vectores_Blanco.png"
                src="../assets/AlfaPack_Logo_Vectores_Blanco.png"
                width="150"
              />
            </router-link>
          </div>
          <div class="level-item level-right">
            <a
              href="https://www.linkedin.com/company/alfapacksolutions/about/?viewAsMember=true"
              target="_blank"
            >
              <svg-icon
                class="mr-4"
                type="mdi"
                :path="mdiLinkedin"
                style="color: #white; width: 40px; height: 40px"
              ></svg-icon>
            </a>
            <a
              href="https://www.youtube.com/@alfapacksolutions"
              target="_blank"
            >
              <svg-icon
                type="mdi"
                :path="mdiYoutube"
                style="color: #white; width: 45px; height: 45px"
              ></svg-icon>
            </a>
          </div>
        </div>
        <div class="block">
          <div class="columns is-mobile">
            <div
              class="column is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-widescreen is-three-quarters-fullhd is-full-mobile"
            >
              <p class="has-text-white is-size-6">
                Asesoramos e integramos tecnología en las industrias de
                alimentos, bebidas, farmacéutica y empaque. Ofrecemos
                capacitación, servicios y piezas de repuesto para mantener a
                nuestros clientes actualizados y sus máquinas en perfecto
                estado.
              </p>
            </div>
          </div>
        </div>
        <div class="block pb-0">
          <div class="columns is-mobile pb-0">
            <div class="column pb-0 is-mobile">
              <p class="has-text-white is-size-6">
                Derechos Reservados {{ currentYear }} &copy;
              </p>
            </div>
            <div class="column has-text-right has-text-bottom pb-0 is-mobile">
              <button
                class="button is-normal has-background-green has-text-white has-text-weight-bold"
                style="font-family: Calibri"
              >
                Chatea en vivo con Alfapack
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <router-view />
</template>
<script setup lang="ts">
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLinkedin, mdiYoutube } from "@mdi/js";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
</script>
